<div mat-dialog-content class="container">
    <div class="modal-header">
        <i class="material-icons color-blue">info</i>
        <p class="modal-title color-blue">{{'support.name' | translate}}</p>
        <span class="material-icons close-button" (click)="closeDialog()">close</span>
    </div>

    <div class="modal-content">
        <div class="hello">
            <img src="../../../assets/img/hello.svg" />
            <span>{{'support.modal.hello' | translate}}</span>
        </div>

        <div class="margin">
            <div class="card-contact">
                <div class="img-section">
                    <img src="../../../assets/img/email-check.svg" />
                </div>
                <div class="texto">
                    <span class="title-contact"> {{'support.modal.contactUsEmail' | translate}}</span>
                    <span class="subtitle-contact">{{ supportEmail }}</span>
                </div>
            </div>
        </div>
    </div>
</div>